import React, { useState, useEffect, createRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "./addpin.scss";
import Button from "components/Button/index";

import { signInContext } from "context/SigninContext";
import { useToast } from "components/Toaster/index";
import { sendAddPin } from "@induz/sdk";
const AddPin = ({
  nextStep,
  title = "Create Pin",
  description = "This pin will be used for future Sign In requests from this system, please note this pin will only work from this system",
  btnText = "Enter Pin",
  ids
}) => {
  const [count] = useState(6);
  const [pin, setPin] = useState("");
  const [showError, setShowError] = useState(false);
  const navigate = useNavigate();

  const { user } = useContext(signInContext);
  const [refs] = useState(
    Array(count)
      .fill(1)
      .map(() => createRef())
  );

  const updatePinState = () => {
    const otpValue = refs.map((ref) => ref.current.value || "").join("");
    setPin(otpValue);

    if (otpValue.length === 0) {
      setShowError(false);
    }
  };

  const isDigit =(k)=> /^[0-9]$/.test(k);

  const handleChange = (val, ref, idx) => {
    
    const digit = val.replace(/\D/g, "").slice(-1); // Get only the last digit, remove non-numeric
  
    if (!digit) {
      ref.current.value = "";
      return;
    }
  
    ref.current.value = digit;

    const updatedPin = [...pin];
    updatedPin[idx] = val;

    

    setPin(updatedPin.join("")); // Ensures all characters are stored properly

    if (val && idx < count - 1) {
      refs[idx + 1].current.focus();
    } else if (!val && idx > 0) {
      refs[idx - 1].current.focus();
    }

    if (showError) {
      setShowError(false); // Remove error when user starts typing again
    }
  };

  const handleKeyDown = (e, ref, idx) => {
    // console.log(e.key, "key pressed");

    if(isDigit(e.key)){
      e.preventDefault();
      ref.current.value = e.key; // Set the input value to the digit pressed

      const otpArray = refs.map((r)=> r.current.value || "");
      otpArray[idx]= e.key;
      setPin(otpArray.join(""));

      if(idx < count -1){
        refs[idx+1].current.focus();
      }

      return;

      


    }
    if (e.key === "Backspace") {
      if (!ref.current.value && idx > 0) {
        refs[idx - 1].current.focus();
        refs[idx - 1].current.value = "";
        updatePinState();
      }
    }

    if (e.key === "Enter") {
      const isPinComplete = pin.length === count;
      if (isPinComplete) {
        addPin1();
      }
    }

    if (e.key === "ArrowLeft") {
      if (idx > 0) {
        refs[idx - 1].current.focus();
        setTimeout(() => {
          refs[idx - 1].current.setSelectionRange(1, 1);
        }, 0);
      }
      e.preventDefault(); // prevent native cursor behavior
    }
    if (e.key === "ArrowRight") {
      if (idx < count - 1) {
        refs[idx + 1].current.focus();
        setTimeout(() => {
          refs[idx + 1].current.setSelectionRange(1, 1);
        }, 0);
      }
      e.preventDefault(); // prevent native cursor behavior
    }
  };

  const handleClick = (idx) => {
    refs[idx].current.focus();
  };

  useEffect(() => {
    refs[0].current.focus();
    refs.forEach((ref)=>{
      if(ref.current){
        ref.current.value= ""; //
      }
    });

    setPin("");
  }, []);
  const showToast = useToast();
  const [loading, setLoading] = useState(false);
  const addPin1 = async () => {
    
    try {
      setLoading(true);
      const pinName = "session-" + Math.random().toString(36).substring(2, 15);
      const result = await sendAddPin(
        user.getEmail(),
        pin,
        pinName
      );
      
      const result1 = btoa(String.fromCharCode(...new Uint8Array(result)));
      localStorage.setItem("izauthtoken", result1);
      localStorage.setItem("pinName", pinName);
      navigate("/homepage");
    } catch (error) {
      setLoading(true);
      
      showToast(error.message, "error");
    }
  };

  // const handleDashboard = () => {
  //   navigate("/homepage");
  // };

  return (
    <>
      {(
        <section className="addpin">
          <div className="container addpinContainer">
            <div className="addpinBox">
              <div className="commonHeading">
                <h1>{title}</h1>
                <p>{description}</p>
              </div>
              <div className="addpinCodeBox">
                <div className="pinContainer">
                  <div className="inputsWrapper" id={ids}>
                    {refs.map((ref, idx) => (
                      <input
                        ref={ref}
                        style={{
                          border:
                            showError && "1px solid var(--accent-colors-red)"
                        }}
                        maxLength={1}
                        key={`input-${idx + 1}`}
                        id={`input-${idx + 1}`}
                        name={`input-${idx + 1}`}
                        onChange={(e) => handleChange(e.target.value, ref, idx)}
                        onKeyDown={(e) => handleKeyDown(e, ref, idx)}
                        onClick={() => handleClick(idx)}
                        inputMode="numeric"
                        autoComplete="off"
                        type="password"
                      />
                    ))}
                  </div>
                  <span
                    style={{ visibility: showError ? "visible" : "hidden" }}
                    className="errorText"
                  >
                    Please enter the valid pin
                  </span>
                </div>
                <Button
                loading={loading}
                  title={btnText}
                  type="violet"
                  // onClick={showSuccess}
                  onClick={() => {
                    
                    addPin1();
                  }}
                  disabled={pin.length < 6}
                />
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

export default AddPin;
